import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  Pagination,
  PaginationCompact,
  PaginationItem
} from '@one-thd/sui-atomic-components';
import { updateParams, shouldIncludeHref } from '../utils/pageNavigation';

const ProductResultsPageLinks = ({
  channel = 'desktop',
  paginationProps = {},
  path = '',
  pageSize = 24,
}) => {
  const { channel: contextChannel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile' || contextChannel === 'mobile';

  const {
    page,
    count = 1
  } = paginationProps;

  const getPaginationItem = (item) => {
    const includeHref = !!path.trim() && shouldIncludeHref(item, page, count);

    return (
      <PaginationItem
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...item}
        href={includeHref ? updateParams(path, pageSize, item.page) : undefined}
      />
    );
  };

  const componentProps = {
    ...paginationProps,
    renderItem: getPaginationItem
  };

  return (
    <div data-component="ProductResultsPageLinks">
      {isMobile
        // eslint-disable-next-line react/jsx-props-no-spreading
        ? <PaginationCompact {...componentProps} showFirstButton showLastButton />
        // eslint-disable-next-line react/jsx-props-no-spreading
        : <Pagination {...componentProps} />}
    </div>
  );
};

ProductResultsPageLinks.displayName = 'ProductResultsPageLinks';

ProductResultsPageLinks.propTypes = {
  channel: PropTypes.string,
  paginationProps: PropTypes.shape({}),
  path: PropTypes.string,
  pageSize: PropTypes.number
};

export { ProductResultsPageLinks };